import { render, staticRenderFns } from "./PurimTransactions.vue?vue&type=template&id=7fdc126e&"
import script from "./PurimTransactions.vue?vue&type=script&lang=js&"
export * from "./PurimTransactions.vue?vue&type=script&lang=js&"
import style0 from "./PurimTransactions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports